export enum DraftStrategyTypes {
  ZERO_RB = 'ZERO RB',
  LATE_ROUND_QB = 'LATE-ROUND QB',
  QB_WR_TE_STACKING = 'QB-WR/TE STACKING',
}
